module.exports = __webpack_public_path__ + "img/jerusalem.d32cbc04.png";